import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from '@/lib/toast'
import i18n from '@/i18n'
import { api } from '@/lib/api'
import type { VoiceNote } from '@/lib/types'

export function useContactVoiceNotes(contactId: string | undefined) {
  return useQuery({
    queryKey: ['voice-notes', contactId],
    queryFn: () =>
      api<{ items: VoiceNote[]; total: number }>(`/api/contacts/${contactId}/voice-notes`).then(
        (r) => r.items,
      ),
    enabled: !!contactId,
  })
}

export function useDeleteVoiceNote() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api<void>(`/api/voice-notes/${id}`, { method: 'DELETE' }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['voice-notes'] })
      toast.success(i18n.t('toast.voiceNoteDeleted'))
    },
    onError: () => {
      toast.error(i18n.t('toast.error'))
    },
  })
}
